import { useContext } from "react";
import { MetadataContext } from "../Contexts/MetadataContext";

export const useMetadata = () => {
  return useContext(MetadataContext);
};
